import { FC } from 'react';
import { ESelectedGamesCardLayoutsType } from 'interfaces/selected-games';
import { AdvancedSelectedGameCardSkeleton } from 'newcomponents/Shared/sportsbook/SelectedGameCard/Advanced/skeleton';
import { BasicSelectedGameCardSkeleton } from 'newcomponents/Shared/sportsbook/SelectedGameCard/Basic/skeleton';
import { ISelectedGamesSkeletonWrapperProps } from 'newcomponents/Shared/sportsbook/SelectedGameCard/types';

export const SelectedGameCardSkeleton: FC<
  ISelectedGamesSkeletonWrapperProps
> = ({ cardLayoutsType, ...props }) => {
  if (
    Number(cardLayoutsType) === Number(ESelectedGamesCardLayoutsType.advanced)
  ) {
    return <AdvancedSelectedGameCardSkeleton {...props} />;
  }

  return <BasicSelectedGameCardSkeleton {...props} />;
};
